import AppointmentOnboardingModal from './AppointmentOnboardingModal';

export default AppointmentOnboardingModal;
